import React, { useMemo } from 'react';

import { AgGridReact } from 'ag-grid-react';

import { ComponentParamsProvider } from 'lib/context/ComponentParamsContext/ComponentParamsProvider';

import Typography from 'components/shared/Typography/Typography';

import {
  ALLOWABLE_AMOUNT_TEXT,
  COLUMN_DEFS,
  DEFAULT_COLUMN_DEFS,
  getAllowableAmountTooltip
} from './lib/helpers';

const PayerTable = ({ formik, practice = null }) => {
  const payers = useMemo(() => formik.values.paySchedule || [], [formik.values.paySchedule]);
  const isDental = practice?.kind === 'dental';

  return (
    <div className="flex flex-col gap-4">
      <Typography
        iconRight="info-mono"
        color="gray-800"
        iconColor="text-gray-600"
        weight="medium"
        tooltip={getAllowableAmountTooltip(isDental)}>
        {ALLOWABLE_AMOUNT_TEXT}
      </Typography>
      <ComponentParamsProvider formik={formik}>
        <div className="ag-theme-quartz  h-fit shadow-none">
          <AgGridReact
            rowData={payers}
            columnDefs={COLUMN_DEFS}
            defaultColDef={DEFAULT_COLUMN_DEFS}
            domLayout="autoHeight"
          />
        </div>
      </ComponentParamsProvider>
    </div>
  );
};

export default PayerTable;
